import { matchPath } from "react-router-dom";

/** Returns whether the current URL should highlight this menu item (supports nested routes). */
export function menuMatchesLocation(pathname, menuItem) {
  const hasExtraPaths =
    Array.isArray(menuItem.activeMatchPaths) && menuItem.activeMatchPaths.length > 0;
  const paths = hasExtraPaths ? menuItem.activeMatchPaths : [menuItem.path];
  const exact = hasExtraPaths ? true : menuItem.exact === true;
  return paths.some((p) => p && matchPath(pathname, { path: p, exact }) != null);
}
